export enum WebsiteHeaderSelectors {
  HeaderPlaceholder = '#SITE_HEADER-placeholder',
  Header = '#SITE_HEADER',
  FreemiumBannerCssSelector = '--wix-ads-top-height',
  ForumTopId = 'navigation-scroller',
}
